import { render, staticRenderFns } from "./CashSettlementsForm.vue?vue&type=template&id=53a8d15a&"
import script from "./CashSettlementsForm.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports